module.exports = __webpack_public_path__ + "img/logo.ce604a38.svg";